<template>
  <layout :title="pageTitle">
    <div class="block">
      <a class="anchor" name="successDrivers"></a>
      <hr />
      <div class="title-bar">
        <h3>Success Drivers</h3>
        <div class="buttons">
          <b-loading
            :is-full-page="isFullPage"
            v-model="isLoading"
            :can-cancel="true"
          ></b-loading>
          <csv-upload @uploaded="csvSubmit" v-model="questionSetCSV" />
        </div>
      </div>
      <hr />
    </div>

    <draggable
      v-model="successDriversForm"
      group="people"
      @start="drag = true"
      @end="drag = false"
    >
      <div
        class="card box"
        animation="slide"
        v-for="(successdriver, index) in successDriversForm"
        :key="index"
      >
        <div class="columns">
          <div class="column">
            <b-field label="Success Driver Name" style="width: 100%">
              <b-input v-model="successdriver.name" expanded></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Success Driver Description" style="width: 100%">
              <b-input v-model="successdriver.description" expanded></b-input>
            </b-field>
          </div>
        </div>
        <div class="">
          <div class="content">
            <p><b>Questions</b></p>
            <table>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th align="right">Shown for self feedback</th>
                <th align="right">Shown for Internal</th>
                <th align="right">Shown for External</th>
              </tr>
              <draggable
                v-model="successdriver.questions"
                tag="tbody"
                @start="drag = true"
                @end="drag = false"
              >
                <tr
                  v-for="(question, index) in successdriver.questions"
                  :key="question.id"
                >
                  <td scope="row">
                    <b-input v-model="question.name"></b-input>
                  </td>
                  <td>
                    <b-select v-model="question.type" expanded>
                      <option value="slider" selected>Slider</option>
                      <option value="text">Text</option>
                      <option value="radio">Radio</option>
                    </b-select>
                  </td>
                  <td align="right">
                    <b-checkbox v-model="question.isShownForSelfFeedback">
                    </b-checkbox>
                  </td>
                  <td align="right">
                    <b-checkbox v-model="question.isShownForInternal">
                    </b-checkbox>
                  </td>
                  <td align="right">
                    <b-checkbox v-model="question.isShownForExternal">
                    </b-checkbox>
                  </td>
                  <td>
                    <div
                      class="icon-container"
                      @click="removeQuestion(successdriver, index)"
                    >
                      <b-icon
                        pack="fas"
                        icon="trash"
                        type="is-danger"
                        size="is-small"
                      ></b-icon>
                    </div>
                  </td>
                </tr>
              </draggable>
            </table>

            <b-button
              type="is-primary"
              outlined
              @click="addQuestion(successdriver)"
              >Add Question</b-button
            >
          </div>
        </div>
      </div>
    </draggable>

    <div class="columns">
      <div class="column" style="padding-top: 30px">
        <b-button type="is-primary" outlined @click="addSuccessDriver()"
          >Add Success Driver</b-button
        >
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <button @click="submit" type="submit" class="button is-primary">
          Next
        </button>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '../Layout';
// https://github.com/SortableJS/Vue.Draggable
import Draggable from 'vuedraggable';
import CsvUpload from '../../../Components/Management/CsvUpload';

export default {
  components: {
    Layout,
    Draggable,
    CsvUpload,
  },
  props: {
    questionSet: { type: Object },
    projectID: { type: String },
  },
  data() {
    return {
      pageTitle:
        'Setup Success Drivers for Question Set: ' + this.questionSet.name,
      questionSetCSV: null,
      successDriversForm: this.questionSet.success_drivers,
      edit: true,
      isFullPage: true,
      isLoading: false,
    };
  },
  methods: {
    submit() {
      this.$inertia.post(
        route(
          'question-sets.setup.successDrivers',
          this.questionSet.unique_id,
          this.project?.unique_id
        ),
        {
          successDrivers: this.successDriversForm,
          projectID: this.projectID,
        }
      );
    },
    csvSubmit: function (file) {
      const data = new FormData();
      data.append('questionSetCSV', file);

      data.append('_token', this.$page.props.csrf_token);

      this.isLoading = true;

      fetch(route('question-set.questionSetCSV'), {
        method: 'POST',
        body: data,
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.successDriversForm = data;
        });

      this.isLoading = false;
    },
    addQuestion: function (successdriver) {
      successdriver.questions.push({
        name: '',
        type: 'slider',
        isShownForSelfFeedback: 1,
        isShownForInternal: 1,
        isShownForExternal: 1,
      });
    },
    removeQuestion: function (successDriver, index) {
      successDriver.questions.splice(index, 1);
    },
    addSuccessDriver: function () {
      this.successDriversForm.push({
        id: 0,
        name: '',
        description: '',
        order: this.successDriversForm.length + 1,
        questions: [
          {
            name: '',
            type: 'slider',
            isShownForSelfFeedback: 1,
          },
        ],
      });
    },
  },
};
</script>
